import { TableCell, TableSortLabel, TableRow } from "@mui/material";
import {
  TableColumn,
  SortOrder,
  onSortOrderChangeCb,
  TableRow as CustomTableRow,
} from "./Table.types";

export interface TableHeaderProps {
  columns: TableColumn[];
  sortOrder: SortOrder;
  orderByColumnId: string;
  onSortOrderChange: onSortOrderChangeCb;
  row?: CustomTableRow;
  condensed?: boolean;
}

export const TableHeader = ({
  columns,
  onSortOrderChange,
  orderByColumnId,
  sortOrder,
  row,
  condensed,
}: TableHeaderProps) => {
  return (
    <TableRow>
      <TableCell padding="checkbox" />
      {columns.map(({ id, label, disableSort, size, Header }) => (
        <TableCell
          key={id}
          sortDirection={orderByColumnId === id && sortOrder}
          width={size}
          sx={condensed ? { padding: 0 } : {}}
        >
          {disableSort ? (
            label
          ) : (
            <TableSortLabel
              active={orderByColumnId === id}
              direction={orderByColumnId === id ? sortOrder : "asc"}
              onClick={onSortOrderChange(id)}
            >
              {label}
            </TableSortLabel>
          )}
          {Header ? Header(row) : row?.[id] ?? ""}
        </TableCell>
      ))}
    </TableRow>
  );
};
